import { Routes, Route } from 'react-router-dom';
import { PortalLayout } from './portal-layout';
import { PortalLandingPage } from './portal-landing-page';
import { PortalBidDetailPage } from './portal-bid-detail-page';
import { PortalInvoicesPage } from './portal-invoices-page';
import { PortalProjectActivityPage } from './portal-project-activity-page';
import { PortalProjectSafetyPage } from './portal-project-safety-page';
import { PortalSignedOutPage } from './portal-signed-out-page';

export function PortalPage() {
  return (
    <Routes>
      <Route path="signed-out" element={<PortalSignedOutPage />} />
      <Route path=":token" element={<PortalLayout />}>
        <Route index element={<PortalLandingPage />} />
        <Route path="bids/:bidId" element={<PortalBidDetailPage />} />
        <Route path="invoices" element={<PortalInvoicesPage />} />
        <Route path="projects/:projectId/activity" element={<PortalProjectActivityPage />} />
        <Route path="projects/:projectId/safety" element={<PortalProjectSafetyPage />} />
      </Route>
    </Routes>
  );
}
